module.exports = __webpack_public_path__ + "static/media/15GalleryPuppets.76f9f8d5.jpeg";